import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { importesConComa } from '@/utils/money';

/**
 * Sustituye la coma decimal por punto en los campos de importe del formulario que
 * lo contenga, según se teclea. No pinta nada.
 *
 * Por qué hace falta: los inputs de importe son de texto, así que Formik guarda en
 * `values` lo que se teclea tal cual. Los campos calculados operan sobre ese valor
 * en crudo, y `'57,5' - 30` da `NaN`, que `round2` convierte en `0`. El importe se
 * guardaba bien igualmente —`normalizeImportes` normaliza al enviar—, pero la
 * pantalla mostraba `0,00` mientras tanto y varios bloques ni se renderizaban.
 *
 * Se resuelve aquí, en un único punto dentro del contexto de Formik, en vez de en
 * cada uno de los ~164 sitios que hacen aritmética sobre `values`.
 *
 * Uso: como primer hijo de `<Form>`.
 */
export const NormalizaImportes = () => {
  const { values, setFieldValue } = useFormikContext<Record<string, any>>();

  useEffect(() => {
    const cambios = importesConComa(values);
    if (!cambios) return;
    // Sin revalidar: `yupImporte` ya acepta la coma, así que no hay error que limpiar.
    Object.entries(cambios).forEach(([campo, valor]) => setFieldValue(campo, valor, false));
  }, [values, setFieldValue]);

  return null;
};
